import { makeStyles } from "@material-ui/core/styles";
import {THEME_SECONDARY_COLOR} from '../../Constants';

export default makeStyles(theme => ({
  root: {
    background: 'transparent',
    color: `${THEME_SECONDARY_COLOR}`
  },
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  detailsSec: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0px 20px'
  },
  docSec: {
    flexGrow: 2,
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    // textAlign: 'center',
    padding: '0px 20px',
    // '&>div': {
    //   marginBottom: 20
    // }
  },
  margin: {
    margin: theme.spacing(2, 0)
  },
  actionsContainer: {
    width: '80%',
    margin: '10px auto',
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  docsWrapper: {
    margin: '0px 20px',
    display: 'flex',
    justifyContent: 'space-evenly',
    position: 'relative',
    flexDirection: 'column',
    height: '100%',
    '&>div': {
      flexGrow: 1,
      position: 'relative',
      margin: 10,
      [theme.breakpoints.up('sm')]: {
        display: 'flex'
      },
      '&>div': {
        width: '100%',
        textAlign: 'center',
        margin: 'auto'
      },
    }
  },
  checkbox: {
    display: 'flex',
  //  justifyContent: 'center',
    margin: '10px'
  },
  checkBoxInput: {
    minWidth: 'auto'
  },
  processingLoader: {
    display: 'inline-flex',
    flexDirection: 'column',
    textAlign: 'center',
    '&> div': {
      margin: 'auto'
    }
  },
  fillDataDnd: {
    '& img': {
      // width: 100,
      width: '6.25em',
      height: '6.25em',
      padding: '5px',
      textAlign: 'center',
      border: '1px solid darkgrey'
    },
    '& span': {
      margin: 'auto',
      cursor: 'pointer',
      fontSize: '1rem',
      display: 'inline-flex'
    },
    '& a': {
      color: 'blue',
      textDecoration: 'underline !important',
      curson: 'pointer'
    },
    '&> div': {
      textAlign: 'center',
      // maxWidth: 100
      margin: 'auto'
    }
  },
  dndTitle: {
    [theme.breakpoints.up('sm')]: {
      width: '65%',
      margin: 'auto'
    }
  },
  savedIcon: {
    fontSize: '3rem',
    margin: 'auto',
    display: 'flex',
    color: 'green'
  },
}));
